import { getApi, putApi, deleteApi } from './Api';
import Api from './Api';
import moment from 'moment';

export const getGcodeList = async (count) => {
  const url = `admin/gcodegroup/all/page?page=${count}&size=15`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSearchGcodeList = async (
  count,
  searchForPatientCode,
  endDate,
  searchForHospitalName,
  startDate,
) => {
  const url = `admin/gcodegroup/gcodeGroupSearch/`;
  try {
    const response = await getApi(url, {
      code: searchForPatientCode,
      endDate: moment(endDate).format('yyyy-MM-DD'),
      name: searchForHospitalName,
      startDate: moment(startDate).format('yyyy-MM-DD'),
      page: count,
      size: 15,
    });
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getGcodeDetail = async (id) => {
  const url = `admin/gcodegroup/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getSTLDetail = async (id) => {
  const url = `stl/quality/${id}`;
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const deleteRegenFile = async (id) => {
  const url = `admin/gcodegroup/gcode/${id}`;
  try {
    const response = await deleteApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getImg = async (id) => {
  const url = id + '?1';
  try {
    const response = await getApi(url);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const uploadGcode = async (id, data) => {
  const url = `admin/gcodegroup/${id}`;
  try {
    const response = await putApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const issuedGcode = async (id, data) => {
  const url = `admin/gcodegroup/print/${id}`;
  try {
    const response = await putApi(url, data);
    return response;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};

export const getWoundPicture = async (path) => {
  const url = `admin/gcodegroup/download-gcs-file/get-wound-picture`;
  try {
    const response = await Api.get(url, {
      params: { path: path },
      authRequired: true,
      responseType: 'blob',
    });
    return response.data;
  } catch (e) {
    console.log('Error => ', e);
    throw e;
  }
};
